<template>
	<div style="height:80%;display: flex; justify-content: center; align-items: center">
		<div style="width: 100%">
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">订单号</label></div>
				<div class="weui-cell__bd">
					<input class="weui-input" v-model="orderSn" type="text" placeholder="请输入"/>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">停车场ID</label></div>
				<div class="weui-cell__bd">
					<input class="weui-input" v-model="parkinglotId" type="number" placeholder="请输入"/>
				</div>
			</div>
			<div class="weui-cell weui-cell_active">
				<div class="weui-cell__hd"><label class="weui-label">金额</label></div>
				<div class="weui-cell__bd">
					<input class="weui-input" v-model="money" type="number" placeholder="请输入"/>
				</div>
			</div>

			<button class="weui-btn weui-btn_default" @click="toPay">支付</button>
		</div>

	</div>
</template>

<script>
	import {pay} from "../../api/coupon/pay";

    export default {
        name: "payMoney",
		data () {
            return {
                orderSn: undefined,
                parkinglotId: undefined,
				money: undefined
			}
		},
		methods: {
            toPay () {
                let payForm = {
                    orderSn: this.orderSn,
                    totalAmount: parseFloat(this.money).toFixed(2),
                    goodsType: 3,
                    parkinglotId: this.parkinglotId,
                    payType: 13,
					openId: localStorage.getItem('userOpenId')
                };
                pay(payForm).then(res =>{
                    if (res.code == 200){
                        this.$pay(res)
                    }
                })
            },
		}
    }
</script>

<style scoped>

</style>
